module.exports = __webpack_public_path__ + "static/img/jp6.1871fa46.png";